<template>
    <div>
        <!-- Aquí incluimos el componente del mapa -->
        <RealTimeMap :processionId="processionId" />
    </div>
</template>

<script>
import RealTimeMap from '../components/TrackingC.vue';

export default {
    name: 'TrackingView',
    components: {
        RealTimeMap
    },
    data() {
        return {
            processionId: this.$route.params.processionId // Obtiene el ID de la procesión de la URL
        };
    },
};
</script>